import { simpleHash } from 'src/lib/util/strings'
import { fileSuffix } from 'src/lib/util/attachments'
import { assetUrl } from 'src/lib/util/url'

const ornamentCount = 20
// const perOrnament = 4
const url = n => assetUrl(`/ornament_${n}.one-third.png`)

export const generateAvatarImageUrl = id => {
  const hash = (parseInt(simpleHash(String(id)).slice(-3)) % ornamentCount) + 1
  return url(hash)
}

const getAvatarImageSuffix = size => {
  if (!size) return ''
  return ['xs', 'responsive', 'large'].includes(size) ? 'small' : size
}

export const generateAvatarImageStyle = (id, avatar, size, useOriginalSrc) => {
  const userImage = useOriginalSrc
    ? avatar
    : avatar && avatar + fileSuffix(getAvatarImageSuffix(size))

  return {
    src: userImage || generateAvatarImageUrl(id),
    className: 'object-cover block w-full h-full'
  }
}
